export default {
  language(state, langCode) {
    state.language = langCode;
  },
  setMissingTranslations(state, missingTranslations) {
    state.missingTranslations = missingTranslations;
  },
  addMissingTranslation(state, missingTranslation) {
    state.missingTranslations.add(missingTranslation);
  }
};
